import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const ADDRESS_SEARCH_REQUEST = 'ADDRESS_SEARCH_REQUEST';
export const ADDRESS_SEARCH_RESPONSE = 'ADDRESS_SEARCH_RESPONSE';

export function addressSearchRequest(keyword) {
  return {
    type: ADDRESS_SEARCH_REQUEST,
    keyword,
  };
}

export function addressSearchResponse(searchResult) {
  return {
    type: ADDRESS_SEARCH_RESPONSE,
    searchResult,
  };
}

export function searchAddress(keyword) {
  if (!keyword || keyword === '') {
    return;
  }
  return dispatch => {
    dispatch(addressSearchRequest(keyword));
    fetch(`${API_URL}/addresses?keyword=${encodeURI(keyword)}`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(addresses => {
        dispatch(addressSearchResponse(addresses));
      })
      .catch(err => {
        switch (err.response.status) {
          case 400: {
            alert('잘못된 검색어가 입력됐습니다.\n특수문자는 포함할 수 없습니다. 예) !@#$%^&*_<>/?~₩');
            break;
          }
          case 403: {
            alert('서버 인증에 실패했습니다.');
            break;
          }
          default: {
            alert('주소 검색 요청 중 오류가 발생했습니다.');
            break;
          }
        }
      });
  };
}
